module.exports = __webpack_public_path__ + "static/media/flikidsFont.38f464c3.jpg";